import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state :{
        userId: unescape(decodeURI((document.cookie.match(new RegExp("(^| )GASGOO_USER=([^;]*)(;|$)")) || '')[2])).toString().split('|')[2] || 0,
        user_name: unescape(decodeURI((document.cookie.match(new RegExp("(^| )GASGOO_USER=([^;]*)(;|$)")) || '')[2])).toString().split('|')[5] 
        || unescape(decodeURI((document.cookie.match(new RegExp("(^| )GASGOO_USER=([^;]*)(;|$)")) || '')[2])).toString().split('|')[1] 
        || '',
        token: unescape(decodeURI((document.cookie.match(new RegExp("(^| )GASGOO_USER=([^;]*)(;|$)")) || '')[2])).toString().split('|')[6] ,
        time_stamp: unescape(decodeURI((document.cookie.match(new RegExp("(^| )GASGOO_USER=([^;]*)(;|$)")) || '')[2])).toString().split('|')[7] ,
        login_url: "https://passports.gasgoo.com/Login?ReturnUrl=" + window.location.href,
        // login_url: "http://passports.gas.cn/Login?ReturnUrl=" + window.location.href,
        cityArr: [
            ['上海', '河北', '山西', '内蒙古', '辽宁', '吉林', '黑龙江', '江苏', '浙江', '安徽', '福建', '江西', '山东', '河南', '湖北', '湖南', '广东', '广西', '海南', '四川', '贵州', '云南', /*'西藏',*/ '陕西', '甘肃', /*'青海',*//* '宁夏',*/ '新疆', '北京', '天津', '重庆'/*, '香港', '澳门', '台湾'*/],
            ['Shanghai', 'Hebei', 'Shanxi', 'Inner Mongolia', 'Liaoning', 'Jilin', 'Heilongjiang', 'Jiangsu', 'Zhejiang', 'Anhui', 'Fujian', 'Jiangxi', 'Shandong', 'Henan', 'Hubei', 'Hunan', 'Guangdong', 'Guangxi', 'Hainan', 'Sichuan', 'Guizhou', 'Yunnan',/* 'Tibet',*/ 'Shaanxi', 'Gansu', /*'Qinghai', 'Ningxia',*/ 'Xinjiang', 'Beijing', 'Tianjin', 'Chongqing'/*, 'Hong Kong', 'Macao', 'Taiwan'*/],
            ['shanghai', 'hebei', 'shanxi', 'neimenggu', 'liaoning', 'jilin', 'heilongjiang', 'jiangsu', 'zhejiang', 'anhui', 'fujian', 'jiangxi', 'shandong', 'henan', 'hubei', 'hunan', 'guangdong', 'guangxi', 'hainan', 'sichuan', 'guizhou', 'yunnan',/* 'xizang',*/ 'shaanxi', 'gansu', /*'qinghai', 'ningxia', */'xinjiang', 'beijing', 'tianjin', 'chongqing'/*, 'xianggang', 'aomen', 'taiwan'*/],
            ['160000', '260000', '250000', '330000', '210000', '110000', '340000', '190000', '180000', '310000', '320000', '350000', '140000', '270000', '220000', '170000', '130000', '290000', '380000', '120000', '240000', '360000', '230000', '370000', '200000', '300000', '150000', '280000']
        ],
        time_node: '',
        year: '',
        month: ''
    },
    getters:{
        time_node: state => state.time_node,
        year: state => state.time_node.getFullYear(),
        month: state => state.time_node.getMonth() + 1
    },
	actions:{ //异步
        
    },
	mutations:{ //setter
        set_time_node(state, time_node) {
            state.time_node = new Date(time_node);
            state.year = state.time_node.getFullYear();
            state.month = state.time_node.getMonth() + 1;
        }
    },
    
})